import { useEffect, useState } from 'react';
import { FirstTimeViewName } from '../types';
import { useStyleContext } from 'context/StyleContext';

export const useIsFirstTimeView = (viewName: FirstTimeViewName) => {
  const { styleStateKey } = useStyleContext();
  const [showView, setShowView] = useState(false);
  const [isSeenView, setIsSeenView] = useState(true);

  const USER_NAME_AND_ORG_NAME = styleStateKey.replace('styleState', '');
  const LOCAL_STORAGE_KEY = `${viewName}${USER_NAME_AND_ORG_NAME}`;

  useEffect(() => {
    if (USER_NAME_AND_ORG_NAME === '') return;
    const seen = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (seen === null) {
      setIsSeenView(false);
    }
  }, [LOCAL_STORAGE_KEY]);

  const handleViewHover = () => {
    if (!isSeenView) {
      setShowView(true);
      localStorage.setItem(LOCAL_STORAGE_KEY, 'true');
    }
  };

  const handleViewClose = (onclick: boolean) => {
    if (onclick) {
      setShowView(false);
      setIsSeenView(true);
      return;
    }
    setTimeout(() => {
      setShowView(false);
      setIsSeenView(true);
    }, 2000);
  };

  return {
    showView,
    isSeenView,
    handleViewHover,
    handleViewClose,
  };
};
